import ErrorComponent from "../ErrorComponent";
import VideoNavigationActions from "./VideoNavigationActions";
import VideoPlayer from './VideoPlayer';
const Video = ({
  videoURL,
  showSubmitButton = true,
  onClose,
  onSubmit,
  enableVideoInNewTab = true,
  closeButtonText,
  submitButtonText,
  errorMessage,
  classes
}) => {
  return (
    <>
      {Boolean(errorMessage) ? (
        <ErrorComponent errorMessage={errorMessage} />
      ) : (
        <VideoPlayer videoURL={videoURL} classes={classes} />
      )}
      <VideoNavigationActions
        onClose={onClose}
        onSubmit={onSubmit}
        showSubmitButton={showSubmitButton}
        videoURL={videoURL}
        enableVideoInNewTab={enableVideoInNewTab}
        classes={classes}
        closeButtonText={closeButtonText}
        submitButtonText={submitButtonText}
        isError={Boolean(errorMessage)}
      />
    </>
  );
};

export default Video;
